import { combineReducers } from "redux";
import ormeAgent from "./ormeAgent/ormeAgent.reducer";


export default combineReducers({
  ormeAgent
});
